var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as main from "../export";
import { DataConverter } from "./DataConverterManager";
import axios from "axios";
export class ATRDataConverter extends DataConverter {
}
/**
 * @interface
 *
 * @name ATRDataConverterManager
 * @description Interface exposed by data converter manager Asset-Tracking microservice
 * @author STMicroelectronics, Davide Sergi
 */
export class ATRDataConverterManager {
    constructor(baseUrl, authorizer, region) {
        this.baseUrl = baseUrl;
        this.authorizer = authorizer;
        this.region = region;
    }
    getDataConverters(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/dataconverters`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            const response = yield axios.get(url.href, opt);
            const rawDevices = response.data;
            return rawDevices.map((rd) => this.deserializeDataConverter(rd));
        });
    }
    ;
    deserializeDataConverter(rawDataConverter) {
        const id = rawDataConverter.id;
        const label = rawDataConverter.label;
        const createTimestamp = rawDataConverter.create_timestamp ? new Date(rawDataConverter.create_timestamp) : null;
        const updateTimestamp = rawDataConverter.update_timestamp ? new Date(rawDataConverter.update_timestamp) : null;
        const converterBody = rawDataConverter.convert;
        return new ATRDataConverter(id, label, createTimestamp, updateTimestamp, converterBody);
    }
}
//# sourceMappingURL=ATRDataConverterManager.js.map